import * as React from 'react'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import AddIcon from '@mui/icons-material/Add'

interface IPopupDialog {
  label: string | React.ReactNode
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  disabled?: boolean
  icon?: React.ReactNode
  endIcon?: boolean
  isLoading?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const ActionButton: React.FC<IPopupDialog> = ({
  label,
  onClick,
  disabled,
  icon,
  endIcon,
  isLoading,
  type,
}) => {
  let useIcon: React.ReactNode = <AddIcon />
  if (icon) {
    useIcon = icon
  }
  if (isLoading) {
    useIcon = <CircularProgress color="inherit" size={20} />
  }
  return (
    <Button
      size="small"
      variant="contained"
      startIcon={label && !endIcon && useIcon}
      endIcon={label && endIcon && useIcon}
      onClick={(e) => onClick(e)}
      disabled={isLoading || disabled}
      type={type}
    >
      {label ? label : useIcon}
    </Button>
  )
}

export default ActionButton
